<template>

  <div v-if="instance">

    <form class="form" v-on:submit.prevent="updateInstance">

    <h1>Instance of <router-link :to="{ name: 'tour-edit', params: { id: instance.tour.id }}">{{ instance.tour.name }}</router-link></h1>

      <div class="box">

        <Errors/>

        <div class="form-wrap">
          <div>
            <label for="instance_title">Title </label>
            <input id="instance_title" type="text" v-model="instance.instance_title">
          </div>

          <div>
            <label for="departure-date">Departure date</label>
            <input id="departure-date" type="date" v-model="instance.departure_date" required>
          </div>

          <div v-if="airports && instance.tour.tour_type == 'air'">
            <label for="departure-airport">Departure airport</label>
            <v-select
              v-model="instance.airport"
              :options="airports"
              label="airport_name"
              id="departure-airport"
              index="id"
            />
          </div>

          <div v-if="pickUpPoints && instance.tour.tour_type == 'coach'">
            <label for="pickup-point">Pickup Point</label>
            <v-select
              v-model="instance.pick_up_point"
              :options="pickUpPoints"
              label="pickup_point_name"
              id="pickup-point"
              index="id"
            />
          </div>

          <div v-if="selfDrive && instance.tour.tour_type == 'self-drive'">
              <label for="self-drive">Self Drive</label>
              <v-select
                v-model="instance.self_drive"
                :option="self_drive"
                label="Self Drive"
                id="self-drive"
                index="id"
              />
          </div>

          <div>
            <label for="deposit-price">Deposit price (£)</label>
            <input id="deposit-price" type="number" v-model="instance.deposit_price" :placeholder="'Set to ' + instance.tour.deposit_price + ' in master'">
          </div>

          <div>
            <label for="base-price">Base price (£)</label>
            <input id="base-price" type="number" v-model="instance.base_price">
          </div>

          <div>
            <label for="base-sale-price">Base sale price (£)</label>
            <input id="base-sale-price" type="number" v-model="instance.base_sale_price">
          </div>

          <div>
            <label for="base-cost">Base cost (£)</label>
            <input id="base-cost" type="number" v-model="instance.base_cost">
          </div>

          <div>
            <label for="base-cost"> Flight Budget (Excluding Luggage)</label>
            <input id="base-cost" type="number" v-model="instance.budgeted_cost">
          </div>

          <div>
            <label for="duration">Duration (days)</label>
            <input id="duration" type="number" v-model="instance.duration">
          </div>

          <div>
            <label for="minimum-age">Minimum age</label>
            <input id="minimum-age" type="number" v-model="instance.minimum_age">
          </div>

          <div>
            <label for="release">Release days before</label>
            <input id="release" type="number" v-model="instance.release_days_before">
          </div>

          <div>
            <label for="places">Places available</label>
            <input id="places" type="number" v-model="instance.tour_places">
          </div>

          <div>
            <label for="stop-sell">Stop sell</label>
            <label class="switch">
              <input id="stop-sell" type="checkbox" v-model="instance.stop_sell">
              <span class="switch__slider"></span>
            </label>
          </div>

          <div>
            <label for="is-special-instance">Is Special Instance</label>
            <label class="switch">
              <input id="is-special-instance" type="checkbox" v-model="instance.is_special_instance">
              <span class="switch__slider"></span>
            </label>
          </div>

        </div>
        <div class="row p-3">
          <div class="col-md-6">
              <div style=" flex-grow: 0; flex-shrink: 0; flex-basis: calc(60% - 1rem);">
                <label for="group_itinerary">Instance itinerary details (Overrides Master & Group itinerary details)</label>
                <textarea id="group_itinerary" style="max-width: 100%; min-height: 8rem" v-model="instance.travel_itinerary"></textarea>
              </div>
            </div>  
        </div>

        <div class="form-wrap form-submit">
          <div class="mt-1" v-if="this.getLoadStatus">
            <button type="submit" class="button" disabled><span>Updating...</span></button>
          </div>
          <div class="mt-1" v-else>
            <button type="submit" class="button" v-if="userRole == 1"><span>Update tour instance</span></button>
          </div>
        </div>

      </div><!-- / box -->

    </form>

    <template v-if="instance.tour.tour_type == 'air'">
      <div class="box mt-5">
        <div class="row">
          <div class="col-md-12 m-3">
            <h3> Flights <ShowHideEye :showSection="showFlightSection" @toggle="showFlightSection = !showFlightSection"/> </h3>
          </div>
        </div>
        <div class="row" v-if="showFlightSection">
          <div class="col-md-12">
            <form class="form" v-on:submit.prevent="saveFlight">
    
              <div class="form-wrap">
    
                <div>
                  <label for="flight-id">Flight</label>
                  <v-select
                    id="flight-select"
                    label="flight_number"
                    :filterable="false"
                    key="id"
                    v-model="newFlight"
                    :options="flights"
                    v-debounce:500ms="searchFlights"
                  >
                    <template slot="option" slot-scope="option">
                      {{ option.flight_number }}
                      {{ option.departure_airport.iata_code}}-{{ option.arrival_airport.iata_code}}
                      {{ option.departure_time | formatDateShort }} @ {{option.departure_time | formatTimeShort}}
                    </template>
                  </v-select>
                </div>
    
                <div class="form-submit-inline">
                  <div v-if="this.getLoadStatus">
                    <button type="submit" class="button" disabled><span>Adding flight...</span></button>
                  </div>
                  <div v-else>
                    <button type="submit" class="button" v-if="userRole == 1"><span>Add flight</span></button>
                  </div>
                </div>
    
              </div>
    
            </form>
    
            <table class="table" cellspacing="0" cellpadding="0" v-if="instance.flights">
              <thead v-if="instance.flights.length > 0">
                <tr>
                  <th>Flight Number</th>
                  <th>Departing</th>
                  <th>Arriving</th>
                  <th>Indirect (out) *</th>
                  <th>Indirect (in) *</th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="flight of instance.flights" :key="flight.id">
                  <td>{{ flight.flight_number }}</td>
                  <td>{{ flight.departure_airport.airport_name}}<br/><small>{{flight.departure_time | formatDateTime}}</small></td>
                  <td>{{ flight.arrival_airport.airport_name}}<br/><small>{{flight.arrival_time | formatDateTime}}</small></td>
                  <td><input type="checkbox" v-model="flight.pivot.indirect_outbound" @change="handleFlightUpdate(flight.id, flight.pivot.indirect_outbound, 'outbound','indirect')"></td>
                  <td><input type="checkbox" v-model="flight.pivot.indirect_inbound" @change="handleFlightUpdate(flight.id, flight.pivot.indirect_inbound, 'inbound','indirect')"></td>
                  <td class="table-action"><a v-on:click="editFlight(flight.id)" class="icon icon--more">Edit</a></td>
                  <td class="table-action"><a v-on:click="deleteFlight(flight.id)" class="icon icon--delete" v-if="userRole == 1">Delete</a></td>
                </tr>
                <tr><td colspan="7"><small>* Please Mark the flights as inbound / outbound.</small></td></tr>
                <tr><td colspan="7"><small>* If flights are indirect please indicate whether they are inbound or outbound. Please mark all legs. There is no need to mark direct flights.</small></td></tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </template><!-- / flights -->

    <template>

      <div class="box">
          <div class="row">
            <div class="col-md-12 m-3">
              <h3> Prices 
                  <small v-if="accommodationFromGroup == true">
                    (Accommodation overriden by <router-link :to="{ name: 'tour-group', params: { id: instance.group.id }}">group</router-link>)
                  </small>
                  <ShowHideEye :showSection="showPriceSection" @toggle="showPriceSection = !showPriceSection"/>
                </h3>
                <p class="m-3">Any values entered below will override prices calculated from the base price and room supplements. Any values left at 0.00 will fallback to the base price with supplements.</p>
            </div>
          </div>
          <template v-if="instance.tour.accommodation.length > 0">
            <div class="row" v-if="showPriceSection">
              <div class="col-md-12">
                <table class="table" cellspacing="0" cellpadding="0" v-if="instance.tour.accommodation">
                  <thead>
                    <tr>
                      <th>Room name</th>
                      <th>Board basis</th>
                      <th>Occupancy</th>
                      <th>Cost (£)</th>
                      <th>Price (£)</th>
                      <th>Sale price (£)</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="accommodation of instance.tour.accommodation">
                      <tr :key="'accommodation-' + accommodation.id">
                        <td colspan="6"><strong>{{ accommodation.details.accommodation_name }}</strong></td>
                        <td><a v-on:click="editAccommodation(accommodation.id)" class="icon icon--more">Edit</a></td>
                      </tr>
                      <PriceTableRow v-for="room of accommodation.rooms" :key="'room-' + room.id" :instance-id="instance.id" :room="room"/>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="row" >
              <div class="col-md-12">
                <p>To enter prices please first <router-link :to="{ name: 'tour-edit', params: { id: instance.tour.id }}">add accommodation to the tour</router-link></p>
              </div>
            </div>
          </template>
      </div>
    </template>
    <!-- / flights -->

    <!-- Bookings -->
    <template>
      <div class="box mt-5">
        <div class="row">
          <div class="col-md-10 m-3">
            <h3> Bookings for this tour instance <ShowHideEye :showSection="showBookingSection" @toggle="showBookingSection = !showBookingSection"/> </h3>
          </div>
          <div class="col-md-2 m-3" v-if="userRole == 1">
            <TriggerSMS :bookings="selectedBookings" />
          </div>
        </div>
        <div class="row" v-if="showBookingSection">
          <div class="col-md-12">
            <table class="table" cellspacing="0" cellpadding="0" >
              <thead>
                <tr>
                  <th>
                    <input type="checkbox" v-model="selectAll" @change="toggleSelectAll" />
                  </th>
                  <th>Booking ref</th>
                  <th>Airline Ref No</th>
                  <th>Accommodation</th>
                  <th>Customer</th>
                  <th>Date booked</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="booking of instance.bookings" :key="booking.id" :class="[!!booking.booking[0].cancelled_at ? 'booking--cancelled' : false]">
                  <td>
                    <input type="checkbox" v-model="selectedBookings" :value="booking.holiday_booking_id">
                  </td>
                  <td><router-link :to="{ name: 'booking-edit', params: { id: booking.booking[0].id }}" :class="(booking.booking[0].changes_accepted == 0 ) ? 'color-orange' : ''">{{ booking.booking[0].booking_ref || booking.booking[0].old_booking_id }}</router-link></td>
                  <td>{{ booking.airline_ref ? booking.airline_ref : '-' }}</td>
                  <td v-if="booking.room">
                    {{ booking.room.accommodation.details.accommodation_name }} 
                    <small>{{ booking.room.name }} - {{ booking.room.board_basis }}</small>
                     <template v-if="booking.selected_multiple_room"> <strong> ({{ booking.selected_multiple_room }}) </strong> </template>
                  </td>
                  <td v-else>-</td>
                  <td v-if="booking.booking[0].customer"><router-link :to="{ name: 'customer-edit', params: { id: booking.booking[0].customer.id }}">{{ booking.booking[0].customer.first_name }} {{ booking.booking[0].customer.last_name }}</router-link></td>
                  <td v-else>No customer attached to booking</td>
                  <td>{{ booking.booking[0].created_at | formatDateTime }}</td>
                  <td class="table-action"><a v-on:click="viewBooking(booking.booking[0].id)" class="icon icon--more">View</a></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </template>
    <!-- / Bookings -->
  </div><!-- / instance -->
</template>

<script>
import ShowHideEye from '@/components/ShowHideEye.vue'
import moment from 'moment'
import Errors from '@/components/Errors.vue'
import PriceTableRow from '@/components/PriceTableRow.vue'
import TriggerSMS from "@/components/TriggerSMS.vue";

import {mapGetters} from 'vuex'
export default {
  name: 'InstanceEdit',
  computed: {
    ...mapGetters(['getLoadStatus']),
    userRole() {
      let user_role = localStorage.getItem("user_role");
      if (user_role == 1) {
        this.showFlightSection = true
        this.showPriceSection = true
        this.showBookingSection = true
      }
      return user_role
    },
  },
  data () {
    return {
      instance: null,
      airports: [],
      pickUpPoints: [],
      flights: [],
      errors: null,
      newFlight: null,
      newPrices: [],
      loading: false,
      accommodationFromGroup: false,
      showFlightSection: false,
      showPriceSection: false,
      showBookingSection: false,
      selectAll: false,
      selectedBookings:[]
    }
  },
  components: {
    Errors,
    PriceTableRow, ShowHideEye, TriggerSMS
  },
  created () {
    this.getInstance()
    this.getAirports()
    this.getPickupPoints()
  },
  watch: {
    '$route': 'getInstance'
  },
  methods: {
    getInstance () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'tours/instances/' + this.$route.params.id, {
        headers: {
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.$store.dispatch('setLoadStatus')
        this.instance = response.data

        this.instance.departure_date = moment(String(this.instance.departure_date)).format('YYYY-MM-DD')

        // If tour instance group has accommodation with rooms then replace the tour.accommodation data with group.accommodation
        if(this.instance.group.accommodation.length > 0) {
          this.accommodationFromGroup = true
          this.instance.tour.accommodation = this.instance.group.accommodation
        }

      })
    },
    updateInstance () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'tours/instances/' + this.$route.params.id, {
        method: 'POST',
        body: JSON.stringify(this.instance),
        headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      // console.log(JSON.stringify(this.instance))
      .then(res => res.json())
      .then(response => {
        this.errors = response.errors
        if(response.success) {
          this.$notify({
            type: 'success',
            title: response.message
          });
        } else if (response.errors) {
          this.$notify({
            type: 'error',
            title: response.message
          });
        }
        this.$store.dispatch('setLoadStatus')
      });
    },
    searchFlights (search) {
      if(this.$data.loading === false ) {
        this.$data.loading = true
        fetch(this.$api + 'flights/search/' + search, {
          headers: {
            'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          this.$data.flights = response.data
          this.$data.loading = false
        })
      }
    },
    getAirports () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'airports/by_country/GB', {
        headers: {
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.$store.dispatch('setLoadStatus')
        this.airports = response.data
      })
    },
    getPickupPoints () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'pickup', {
        headers: {
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.$store.dispatch('setLoadStatus')
        this.pickUpPoints = response.data
      })
    },
    saveFlight () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'tours/instances/' + this.$route.params.id + '/flights', {
        method: 'POST',
        body: JSON.stringify(this.newFlight),
        headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.$notify({
            type: 'success',
            title: response.message
          });
        this.getInstance()
        this.$store.dispatch('setLoadStatus')
      })
    },
    editFlight(flightID) {
      this.$router.push({ name: 'flight-edit', params: { id: flightID }})
    },
    deleteFlight (flightID) {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'tours/instances/' + this.$route.params.id + '/flights/' + flightID + '/delete', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.errors = response.errors
        if(response.success == true) {
          this.$notify({
            type: 'success',
            title: response.message
          });
          this.getInstance()
        } else if (response.errors) {
          this.$notify({
            type: 'error',
            title: response.message
          });
        } else {
          this.$notify({
            type: 'error',
            title: response.Error
          });
        }
        this.$store.dispatch('setLoadStatus')
      });
    },
    editAccommodation(accommodationId) {
      this.$router.push({ name: 'tour-accommodation', params: { id: accommodationId }})
    },
    handleFlightUpdate(flightID, status, direction, type) {
      fetch(this.$api + 'tours/instances/' + this.$route.params.id + '/flights/' + flightID, {
        method: 'POST',
        body: JSON.stringify({
          type,
          status: status,
          direction: direction
        }),
        headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.$notify({
            type: 'success',
            title: response.message
          });
        this.$store.dispatch('setLoadStatus')
      })
    },
    viewBooking(data) {
      this.$router.push({ name: 'booking-edit', params: { id: data }})
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedBookings = this.instance.bookings.map(item => item.holiday_booking_id);
      } else {
        this.selectedBookings = [];
      }
    },
  }
}
</script>
<style scoped>
.booking--cancelled {
  text-decoration: line-through;
}
</style>